"use client"
import HTMLEmptyModal from "../HTMLModalComponent/HTMLEmptyModal"
import styles from "./modals.module.scss"
import Image from "next/image"
import SText from "../Text/SText"
import { useTranslations } from "next-intl"

const PartnerModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
  const t = useTranslations("index.network")
  return (
    <HTMLEmptyModal isOpened={isOpen} onClose={closeModal} onProceed={() => null} innerModalCSS={styles.doctorModal}>
      <div className={styles.doctorImage}>
        <Image
          width={252}
          height={248}
          src={"/images/modal/investor_img.webp"}
          alt={"Investor Bild"}
          style={{
            maxWidth: "100%",
            height: "auto",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <SText style={{ width: "330px" }} variant={"body"} color={"green400"}>
          {t("afterClick")}{" "}
          <a style={{ color: "#1BC8CC" }} href={"mailto:info@skinuvita.de"}>
            info@skinuvita.de{" "}
          </a>
        </SText>
      </div>
    </HTMLEmptyModal>
  )
}

export default PartnerModal
